// extracted by mini-css-extract-plugin
module.exports =  {"container":"hLPfPIMsrWhJLb99d1Vq","value":"Lqy5e8ftNf05exm4VZJF"};